import type { FC } from 'react';

import { IDADE_MINIMA } from '@maestra/core/utils/age';
import { useContaBloqueada } from '../../../../logica/consentimento/useContaBloqueada';
import { ContaBloqueada } from './ContaBloqueada';

// /conta-bloqueada — liga a lógica à tela.
const ContaBloqueadaLigada: FC = () => {
  const c = useContaBloqueada();
  return <ContaBloqueada {...c} idadeMinima={IDADE_MINIMA} sair={() => { void c.sair(); }} />;
};

export default ContaBloqueadaLigada;
